import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-739c46d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between items-center mb-8" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Sınıflar", -1))
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row gap-2"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-center justify-center space-y-4 bg-white rounded-md shadow-sm p-4 h-96"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-4" }, "Sınıf Ekleyin", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn-primary"
}, " Sınıf Ekleyin", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center max-w-md" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 text-sm" }, " Yeni bir sınıf ekleyin ve daha sonra öğrencilerinizi sınıflara ekleyin. ")
], -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4" }
const _hoisted_11 = { class: "text-lg font-semibold text-gray-800" }
const _hoisted_12 = { class: "text-sm text-gray-600" }
const _hoisted_13 = { class: "flex justify-between items-center mt-4" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold pt-4" }, "Pasif Sınıflar", -1))
const _hoisted_16 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4" }
const _hoisted_17 = { class: "text-lg font-semibold text-gray-800" }
const _hoisted_18 = { class: "text-sm text-gray-600" }
const _hoisted_19 = { class: "flex justify-between items-center mt-4" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ClassRoomDialog = _resolveComponent("ClassRoomDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.classRooms.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateDialog && _ctx.openCreateDialog(...args))),
              class: "btn-primary"
            }, "Sınıf Ekleyin")
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.Loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.classRooms.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classRooms.filter(a => a.isActive), (item, classIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: classIndex,
                class: "bg-white rounded-md shadow-sm p-4"
              }, [
                _createElementVNode("h3", _hoisted_11, _toDisplayString(item.name), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(item.description), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.editClassRoom(item)),
                    class: "text-orange-600 font-semibold"
                  }, "Düzenle", 8, _hoisted_14),
                  _createVNode(_component_router_link, {
                    to: `/classRoom/${item.classRoomId}`,
                    class: "text-indigo-600 font-semibold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Öğrenci Listesi")
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ]),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classRooms.filter(a => !a.isActive), (item, classIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: classIndex,
                class: "bg-white rounded-md shadow-sm p-4"
              }, [
                _createElementVNode("h3", _hoisted_17, _toDisplayString(item.name), 1),
                _createElementVNode("p", _hoisted_18, _toDisplayString(item.description), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.editClassRoom(item)),
                    class: "text-orange-600 font-semibold"
                  }, "Düzenle", 8, _hoisted_20),
                  _createVNode(_component_router_link, {
                    to: `/classRoom/${item.classRoomId}`,
                    class: "text-indigo-600 font-semibold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Öğrenci Listesi")
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ]),
          (_ctx.showDialog)
            ? (_openBlock(), _createBlock(_component_ClassRoomDialog, {
                key: 1,
                classRoom: _ctx.currentClassRoom,
                dialogTitle: _ctx.dialogTitle,
                onSave: _ctx.handleSave,
                onClose: _ctx.closeDialog
              }, null, 8, ["classRoom", "dialogTitle", "onSave", "onClose"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}